<template>
  <div class="main">
    <div class="main-left" :class="{'open':state == 'open','shrink':state == 'shrink'}">
      <img v-if="state == 'open'" class="switch" src="@/assets/img/shrink.png" @click="state = 'shrink'" />
      <img v-else class="switch" src="@/assets/img/open.png" @click="state = 'open'" />
      <template v-if="state == 'open'">
        <div class="userInfo">账号：{{userInfo.username}}</div>
        <div class="search">
          <el-form :model="form" label-width="1.5rem">
            <div class="form-row">
              <el-form-item label="日期">
                <div class="text">{{formatDate.substring(0,10)}}</div>
              </el-form-item>
            </div>
            <div class="form-row">
              <el-form-item label="生产单位">
                <el-select class="form_content" v-model="form.groupsId" placeholder="选择生产单位" @change="groupChange">
                  <el-option v-for="(item,index) in groupList" :value="item.id" :label="item.name" :key="index"></el-option>
                </el-select>
              </el-form-item>
            </div>
            <!-- <div class="form-row">
              <el-form-item label="生产指令">
                <el-input class="form_content" v-model="form.orderNo" placeholder="选择生产指令" readonly>
                  <el-button slot="append" @click="handleShowOrder">选</el-button>
                </el-input>
              </el-form-item>
            </div> -->
            <div class="form-row">
              <el-form-item label="">
                <div class="info_btn" @click="handleShowOrder">选择指令</div>
              </el-form-item>
            </div>
          </el-form>
        </div>
        <div class="info">
          <div class="sub-title">指令信息</div>
          <div class="box">
            <div class="row">
              <div class="label">型体：</div>
              <div class="content">{{info.customerStyle || '未选择生产指令'}}</div>
            </div>
            <div class="row">
              <div class="label">颜色：</div>
              <div class="content">{{info.colorCn || '未选择生产指令'}}</div>
            </div>
            <div class="row">
              <div class="label">数量：</div>
              <div class="content">{{info.orderQuantity + info.preReplenishQuantity || '未选择生产指令'}}</div>
            </div>
          </div>
        </div>
        <div class="info">
          <div class="sub-title">生产状况</div>
          <div class="box">
            <div class="row">
              <div class="label" style="width:1.8rem;">今日目标</div>
              <div class="content">{{fqcInfo.dayTargetQty || 0}}<span class="unit">双</span></div>
            </div>
            <div class="row">
              <div class="label" style="width:1.8rem;">今日投产</div>
              <div class="content">{{fqcInfo.dayFeedQty || 0}}<span class="unit">双</span></div>
            </div>
            <div class="row">
              <div class="label" style="width:1.8rem;">达成比例</div>
              <div class="content">{{fqcInfo.dayReachRate || 0}}<span class="unit">%</span></div>
            </div>
            <div class="row">
              <div class="label" style="width:1.8rem;">人数</div>
              <div class="content">{{fqcInfo.peopleNum || 0}}<span class="unit">人</span></div>
            </div>
          </div>
        </div>
      </template>
    </div>
    <div class="main-content">
      <div class="title">成品品检</div>
      <div class="operate">
        <template v-if="form.groupsId && form.orderNo">
          <div class="clear" @click="clearOrder">清空生产指令</div>
          <div class="clear" @click="delOrder">删除当前生产指令</div>
        </template>
        <div class="logout" @click="logOut">退出</div>
      </div>
      <img v-if="!form.groupsId || !form.orderNo" class="default" src="@/assets/img/default.png" />
      <template v-else>
        <div class="order-list">
          <div class="order-item" :class="{'current':item.orderNo==form.orderNo}" v-for="(item,index) in selectOrderList" :key="index" @click="handleOrderSelect(item)">
            {{item.orderNo}}
          </div>
        </div>
        <!-- <div class="tabs">
          <div class="item" :class="{'active':type==='pass'}" @click="tabChange('pass')">合格</div>
          <div class="item" :class="{'active':type==='ng'}" @click="tabChange('ng')">不良</div>
        </div> -->
        <div class="count">
          <div class="item">生产双数&#x3000;<span class="num">{{fqcInfo.orderDayFeedQty || 0}}</span></div>
          <div class="item">合格双数&#x3000;<span class="num">{{fqcInfo.orderDayFqcQty || 0}}</span></div>
          <div class="item">不良双数&#x3000;<span class="num">{{fqcInfo.orderDayNgQty || 0}}</span></div>
          <div class="item">不良比例&#x3000;<span class="num">{{fqcInfo.orderDayNgRate || 0}}%</span></div>
        </div>
        <div class="pane">
          <div class="box">
            <div class="pass-list" v-if="type==='pass'">
              <div class="item select" :class="{'disabled':item.orderQuantity + item.preReplenishQuantity == 0 || item.fqcQty >= item.orderQuantity + item.preReplenishQuantity}" v-for="item in sizeList" :key="item.id" @click="handlePass(item)">{{item.size}}</div>
              <div class="item" v-for="item in 40" :key="item"></div>
            </div>
            <div class="ng-list" v-if="type==='ng'">
              <div class="item" v-for="item in ngList" :key="item.id">
                <div class="name"  @click="beforeNg(item)">{{item.name}}</div>
                <div class="data">
                  <div class="num">{{ngInfo.find(a => a.fqcTypeId === item.id) ? ngInfo.find(a => a.fqcTypeId === item.id).ngQty : 0}}</div>
                  <div class="percent">{{ngInfo.find(a => a.fqcTypeId === item.id) ? ngInfo.find(a => a.fqcTypeId === item.id).ngRate + '%' : '0%'}}</div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="btns">
            <div class="item">当日投产记录</div>
            <div class="item">当日投产状况</div>
            <div class="item">小时投产状况</div>
            <div class="item">投产未满明细</div>
          </div> -->
        </div>
      </template>
    </div>
    <div class="size-select" v-if="showSize" @click="showSize = false">
      <div class="size-box" @click.stop="">
        <div class="list">
          <div class="item select" :class="{'disabled':item.orderQuantity + item.preReplenishQuantity == 0 || item.feedQty - item.fqcNgQty - item.handQty <= 0}" v-for="item in sizeList" :key="item.id" @click="handleNg(item)">{{item.size}}</div>
          <div class="item" v-for="item in 24" :key="item"></div>
        </div>
      </div>
      <div class="close"></div>
    </div>
    <div class="order-select" v-if="showOrder">
      <div class="order-search">
        <el-form :model="orderSearchForm" label-width="1.2rem" inline>
          <el-form-item label="是否出货">
            <el-select class="form_content" v-model="orderSearchForm.searchCondition.isDelivery" placeholder="是否出货" style="width:3rem;">
              <el-option :value="true" label="已出货"></el-option>
              <el-option :value="false" label="未出货"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指令号">
            <el-input class="form_content" v-model="orderSearchForm.searchCondition.orderNo" placeholder="多指令号 , 隔开" style="width:3rem;"></el-input>
          </el-form-item>
          <el-form-item label="客户型体">
            <el-input class="form_content" v-model="orderSearchForm.searchCondition.customerStyle" placeholder="客户型体" style="width:3rem;"></el-input>
          </el-form-item>
          <el-form-item label="工厂型体">
            <el-input class="form_content" v-model="orderSearchForm.searchCondition.factoryStyle" placeholder="工厂型体" style="width:3rem;"></el-input>
          </el-form-item>
          <div>
            <el-form-item label=" ">
              <div class="info_btn" @click="orderSearch">搜索</div>
              <div class="info_btn" @click="showOrder = false">返回</div>
              <div class="primary_btn" @click="orderSearchAll">确认选择</div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <el-table height="100"
        ref="orderTable"
        :data="orderList" border
        highlight-current-row
        :header-cell-style="{backgroundColor:'#EDF1FF',fontWeight:'bold',color:'#101010'}"
        style="width: 100%;font-size: 0.16rem;" @row-click="rowClick" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55px" align="center" fixed="left"></el-table-column>
        <el-table-column label="客户" prop="customerName" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="指令号" prop="orderNo" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="订单数量" prop="orderQuantity" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="预补数量" prop="preReplenishQuantity" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="型体" prop="customerStyle" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="接单日期" prop="receiptDate" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.receiptDate?scope.row.receiptDate.substring(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="工厂交期" prop="factoryDeliveryDate" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.factoryDeliveryDate?scope.row.factoryDeliveryDate.substring(0,10):''}}</span>
          </template>
        </el-table-column>
        <el-table-column label="颜色" prop="colorCn" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="材质" prop="texture" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="楦头号" prop="shoeLast" align="center" show-overflow-tooltip></el-table-column>
      </el-table>
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="orderSearchForm.current"
        :page-size="orderSearchForm.size"
        @current-change="currentChange"
        :total="orderTotal">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { logout } from '@/api/user'
import { groupList, orderPage, fqcNgTypeList, orderDetail, fqcSize, getFqcInfo, dayFqcQtyInfo } from '@/api/api'

export default {
  data () {
    return {
      userInfo: {},
      form: {
        groupsId: '',
        orderNo: ''
      },
      orderSearchForm: {
        current: 1,
        size: 10,
        searchCondition: {
          isDelivery: false,
          isFqc: false,
          isGroupBy: false,
          isPiece: false,
          isCancel: false,
          typeNameList: ['生产指令']
        }
      },
      orderTotal: 0,
      info: {},
      state: 'open',
      type: 'ng',
      showSize: false,
      showOrder: false,
      ngList: [],
      groupList: [],
      orderList: [],
      selectOrderList: [],
      sizeList: [],
      fqcInfo: {},
      ngInfo: []
    }
  },
  computed: {
    formatDate () {
      const date = new Date()
      const year = date.getFullYear()
      const month = ('0' + (date.getMonth() + 1)).slice(-2)
      const day = ('0' + date.getDate()).slice(-2)
      const hour = ('0' + date.getHours()).slice(-2)
      const minute = ('0' + date.getMinutes()).slice(-2)
      const second = ('0' + date.getSeconds()).slice(-2)
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  },
  mounted () {
    this.userInfo = localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {}
    this.selectOrderList = localStorage.getItem('pj-selectOrderList') ? JSON.parse(localStorage.getItem('pj-selectOrderList')) : []
    this.form.groupsId = localStorage.getItem('groupsId') || (this.userInfo.staff && this.userInfo.staff.groupsId)
    if (this.selectOrderList.length) {
      this.handleOrderSelect(this.selectOrderList[0])
    }

    this.getGroupList()
    this.getNgType()
    this.getOrderList()
    // 检测断网
    window.addEventListener('offline', () => {
      this.$message.warning('网络异常，请重新登录')
      this.$router.push({
        path: '/login'
      })
    })
  },
  methods: {
    // 获取生产单位
    getGroupList () {
      groupList({ deptName: '成型部', disabled: false }).then(res => {
        this.groupList = res.data
        if (localStorage.getItem('groupsId')) {
          this.form.groupsId = localStorage.getItem('groupsId')
        }
      })
    },
    // 获取Ng类型
    getNgType () {
      fqcNgTypeList({ disabled: false }).then(res => {
        this.ngList = res.data
      })
    },
    // 获取生产指令列表（弹窗）
    getOrderList () {
      if (this.orderSearchForm.searchCondition.orderNo) {
        this.orderSearchForm.searchCondition.orderNoInList = this.orderSearchForm.searchCondition.orderNo.split(',')
      } else {
        this.orderSearchForm.searchCondition.orderNoInList = []
      }
      orderPage(this.orderSearchForm).then(res => {
        this.orderList = res.data
        this.orderTotal = res.total * 1
      })
    },
    getOrderInfo () {
      orderDetail(this.info.orderId).then(res => {
        if (res.code === 200) {
          this.sizeList = res.data.sizeList
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    getFqcInfo () {
      const data = {
        date: this.formatDate,
        orderId: this.info.orderId,
        groupsId: this.form.groupsId
      }
      getFqcInfo(data).then(res => {
        this.fqcInfo = res.data
      })
    },
    groupChange () {
      localStorage.setItem('groupsId', this.form.groupsId)
      this.getFqcInfo()
      if (this.form.orderNo) {
        this.getFqcQtyInfo()
      }
    },
    reset () {
      this.form = {
        groupsId: '',
        orderNo: ''
      }
      this.info = {}
    },
    tabChange (type) {
      this.type = type
    },
    handleShowOrder () {
      if (!this.form.groupsId) {
        this.$message.warning('请先选择生产单位')
        return
      }
      this.orderSearch()
      this.showOrder = true
    },
    orderSearch () {
      this.currentChange(1)
    },
    rowClick (row) {
      this.$refs.orderTable.toggleRowSelection(row)
    },
    handleSelectionChange (list) {
      console.log(list)
      this.tableSelectList = list
    },
    orderSearchAll () {
      if (!this.tableSelectList || !this.tableSelectList.length) {
        this.$message.warning('请先选择指令')
        return
      }
      this.tableSelectList.forEach(row => {
        this.orderSelect(row)
      })
    },
    orderSelect (row) {
      if (!this.selectOrderList.find(a => a.id === row.id)) {
        this.selectOrderList.push(row)
      }
      localStorage.setItem('pj-selectOrderList', JSON.stringify(this.selectOrderList))

      this.info = row
      this.form.orderNo = row.orderNo
      this.showOrder = false
      this.getOrderInfo()

      if (this.form.groupsId) {
        this.getFqcQtyInfo()
        this.getFqcInfo()
      }
    },
    handleOrderSelect (item) {
      this.info = item
      this.form.orderNo = item.orderNo
      this.getOrderInfo()
      if (this.form.groupsId) {
        this.getFqcQtyInfo()
        this.getFqcInfo()
      }
    },
    currentChange (current) {
      this.orderSearchForm.current = current
      this.getOrderList()
    },
    // 品检
    handlePass (item) {
      if (item.orderQuantity + item.preReplenishQuantity === 0 || item.fqcQty >= item.orderQuantity + item.preReplenishQuantity) {
        return
      }
      if (!this.form.groupsId) {
        this.$message.warning('请先选择生产单位')
        return
      }
      if (!this.form.orderNo) {
        this.$message.warning('请先选择生产指令')
        return
      }
      const data = {
        fqcTypeId: 0,
        size: item.size,
        fqc: {
          date: this.formatDate,
          manufactureId: this.info.id,
          orderId: this.info.orderId,
          groupsId: this.form.groupsId
        }
      }
      fqcSize(data).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.getOrderInfo()
          this.getFqcInfo()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    beforeNg (item) {
      if (!this.form.groupsId) {
        this.$message.warning('请先选择生产单位')
        return
      }
      if (!this.form.orderNo) {
        this.$message.warning('请先选择生产指令')
        return
      }
      this.currentNg = item.id
      this.showSize = true
    },
    handleNg (item) {
      const data = {
        fqcTypeId: this.currentNg,
        size: item.size,
        fqc: {
          date: this.formatDate,
          manufactureId: this.info.id,
          orderId: this.info.orderId,
          groupsId: this.form.groupsId
        }
      }
      fqcSize(data).then(res => {
        if (res.code === 200) {
          this.$message.success('新增成功')
          this.showSize = false
          this.getOrderInfo()
          this.getFqcQtyInfo()
          this.getFqcInfo()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    getFqcQtyInfo () {
      const data = {
        date: this.formatDate,
        groupsId: this.form.groupsId,
        manufactureId: this.info.id,
        orderId: this.info.orderId
      }
      dayFqcQtyInfo(data).then(res => {
        if (res.code === 200) {
          this.ngInfo = res.data
        } else {
          this.ngInfo = []
        }
      })
    },
    // 清空生产指令
    clearOrder () {
      this.selectOrderList = []
      localStorage.setItem('pj-selectOrderList', [])
      this.info = {}
      this.form.orderNo = ''
    },
    // 删除生产指令
    delOrder () {
      this.selectOrderList = this.selectOrderList.filter(a => a.orderNo !== this.form.orderNo)
      localStorage.setItem('pj-selectOrderList', JSON.stringify(this.selectOrderList))
      if (this.selectOrderList.length) {
        this.info = this.selectOrderList[0]
        this.form.orderNo = this.selectOrderList[0].orderNo
        this.getOrderInfo()
        if (this.form.groupsId) {
          this.getFqcQtyInfo()
          this.getFqcInfo()
        }
      } else {
        this.info = {}
        this.form.orderNo = ''
      }
    },
    // 退出登录
    logOut () {
      logout().then(res => {
        localStorage.removeItem('token')
        this.$router.push({
          path: '/login'
        })
      })
    }
  }
}
</script>

<style lang="scss">
.main {
  display: flex;
  user-select: none;
  .main-left{
    position: relative;
    height: 100%;
    width: 5.66rem;
    background-color: rgba(255,255,255,1);
    box-shadow: 0rem 0rem 0.24rem 0rem rgba(0,0,0,0.3);
    padding-top: 0.65rem;
    box-sizing: border-box;
    transition: 0.1s;
    display: flex;
    flex-direction: column;
    &.shrink{
      width: 1rem;
    }
    .switch{
      position: absolute;
      top: 0.7rem;
      right: 0.35rem;
      width: 0.3rem;
      height: 0.3rem;
    }
    .title{
      text-align: center;
      color: rgba(255,0,0,1);
      font-size: 0.28rem;
      line-height: 0.4rem;
    }
    .sub-title{
      text-align: center;
      color: rgba(15,64,245,1);
      font-size: 0.24rem;
      line-height: 0.8rem;
    }
    .userInfo{
      padding-left: 0.9rem;
      font-size: 0.24rem;
    }
    .search{
      .el-form{
        width: 100%;
        box-sizing: border-box;
        margin-top: 0.3rem;
        .form-row{
          margin-bottom: 0.2rem;
          .el-form-item{
            margin: 0;
            input{
              height: 0.54rem;
              line-height: 0.54rem;
              font-size: 0.22rem;
              padding: 0 0.15rem;
            }
            .el-form-item__label,.el-form-item__content{
              line-height: 0.54rem;
              font-size: 0.22rem;
              padding: 0 0.12rem 0 0;
            }
            .el-input__icon{
              line-height: 0.54rem;
            }
            .primary_btn{
              cursor: pointer;
              display: inline-block;
              width: 2rem;
              height: 0.6rem;
              line-height: 0.6rem;
              text-align: center;
              border-radius: 0.05rem;
              background-color: #0F40F5;
              color: #fff;
              font-size: 0.24rem;
              &:hover,&:active{
                opacity: 0.8;
              }
            }
            .info_btn{
              cursor: pointer;
              display: inline-block;
              width: 2rem;
              height: 0.6rem;
              line-height: 0.58rem;
              text-align: center;
              border-radius: 0.05rem;
              background-color: #fff;
              color: #0F40F5;
              border: 0.01rem solid #0F40F5;
              font-size: 0.24rem;
              box-sizing: border-box;
              &:hover,&:active{
                opacity: 0.8;
              }
            }
            .text{
              font-size: 0.24rem;
              padding: 0 0.15rem;
            }
          }
          .form_content{
            display: flex;
            margin-right: 0.45rem;
            font-size: 0.14rem;
            width: auto;
            .el-form-item__content{
              flex: 1;
            }
            .el-input-group__append{
              padding: 0;
              width: auto;
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.2rem;
              .el-button{
                padding: 0.12rem 0.2rem;
                margin: 0;
              }
            }
          }
        }
      }
    }
    .info{
      padding: 0 0.45rem;
      .box{
        border: 0.01rem solid rgba(15,64,245,1);
        border-radius: 0.1rem;
        padding: 0.2rem;
        .row{
          line-height: 0.5rem;
          display: flex;
          .label{
            color: rgba(0,0,0,1);
            font-size: 0.24rem;
          }
          .content{
            flex: 1;
            color: rgba(15,64,245,1);
            font-size: 0.24rem;
            .unit{
              float: right;
              color: rgba(0,0,0,1);
              margin-right: 0.2rem;
            }
          }
        }
      }
    }
  }
  .main-content{
    position: relative;
    flex: 1;
    width: 0;
    padding-top: 0.9rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title{
      position: absolute;
      top: 0.3rem;
      left: 0.3rem;
      font-size: 0.36rem;
      font-weight: bold;
    }
    .operate{
      position: absolute;
      top: 0.3rem;
      right: 0.3rem;
      display: flex;
      .clear{
        padding: 0 0.1rem;
        height: 0.5rem;
        border: 0.01rem solid rgba(15,64,245,1);
        color: rgba(15,64,245,1);
        font-size: 0.24rem;
        border-radius: 0.05rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-left: 0.2rem;
        &:active{
          opacity: 0.8;
        }
      }
      .logout{
        width: 1rem;
        height: 0.5rem;
        background-color: rgba(15,64,245,1);
        color: #fff;
        font-size: 0.24rem;
        border-radius: 0.05rem;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        margin-left: 0.2rem;
        &:active{
          opacity: 0.8;
        }
      }
    }
    .default{
      width: 7.9rem;
      height: 7.9rem;
    }
    .order-list{
      display: flex;
      width: calc(100% - 1.75rem);
      align-items: center;
      margin-left: 1.3rem;
      margin-right: 1.45rem;
      margin-bottom: 0.2rem;
      overflow: auto;
      white-space: nowrap;
      .order-item{
        display: inline-block;
        cursor: pointer;
        font-size: 0.28rem;
        border: 0.01rem solid rgba(15,64,245,1);
        color: rgba(15,64,245,1);
        padding: 0.15rem 0.1rem;
        margin: 0.1rem;
        border-radius: 0.1rem;
        &.current{
          color: #fff;
          background-color: rgba(15,64,245,1);
        }
      }
    }
    .tabs{
      width: 6rem;
      height: 0.7rem;
      border: 0.01rem solid rgba(15,64,245,1);
      border-radius: 0.35rem;
      display: flex;
      .item{
        cursor: pointer;
        flex: 1;
        color: #0F40F5;
        font-size: 0.28rem;
        text-align: center;
        height: 100%;
        line-height: 0.7rem;
        border-radius: 0.35rem;
        &.active{
          color: #fff;
          background-color: rgba(15,64,245,1);
        }
      }
    }
    .count{
      display: flex;
      margin-top: 0.4rem;
      .item{
        font-size: 0.28rem;
        margin: 0 0.4rem;
        .num{
          color: rgba(255,0,0,1);
        }
      }
    }
    .pane{
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      justify-content: space-evenly;
      .box{
        margin-left: 1.3rem;
        margin-right: 1.45rem;
        width: calc(100% - 2.75rem);
        border: 0.01rem solid rgba(15,64,245,1);
        border-radius: 0.5rem;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        .pass-list{
          margin: 0.46rem 0.8rem;
          height: 6.08rem;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          overflow: hidden;
          .item{
            width: 1.5rem;
            height: 1.5rem;
            border: 0.01rem solid rgba(15,64,245,1);
            border-radius: 0.1rem;
            box-sizing: border-box;
            margin: 0.01rem;
            background-color: rgba(15,64,245,0.1);
            &.select{
              background-color: rgba(15,64,245,1);
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.42rem;
              color: #fff;
              cursor: pointer;
              &:active{
                opacity: 0.8;
              }
              &.disabled{
                background-color: #DDD;
                border: 0.01rem solid #DDD;
                &:active{
                  opacity: 1;
                }
              }
            }
          }
        }
        .ng-list{
          margin: 0.46rem 0.3rem;
          display: flex;
          flex-wrap: wrap;
          width: 100%;
          .item{
            width: calc(100% / 3 - 0.6rem);
            height: 1.7rem;
            margin: 0.15rem 0.3rem;
            border-radius: 0.1rem;
            border: 0.01rem solid rgba(15,64,245,1);
            box-sizing: border-box;
            overflow: hidden;
            display: flex;
            .name{
              width: 65%;
              height: 100%;
              background: #0F40F5;
              display: flex;
              align-items: center;
              justify-content: center;
              color: #fff;
              font-size: 0.32rem;
              cursor: pointer;
              padding: 0 0.1rem;
              box-sizing: border-box;
              &:active{
                opacity: 0.8;
              }
            }
            .data{
              width: 35%;
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              div{
                flex: 1;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 0.24rem;
              }
              .num{
                border-bottom: 0.01rem solid #0F40F5;
              }
            }
          }
        }
      }
      .btns{
        margin-left: 1.3rem;
        margin-right: 1.45rem;
        display: flex;
        justify-content: space-around;
        width: calc(100% - 2.75rem);
        .item{
          cursor: pointer;
          width: 1.74rem;
          height: 0.7rem;
          line-height: 0.7rem;
          text-align: center;
          border-radius: 0.05rem;
          background-color: rgba(15,64,245,1);
          color: #fff;
          font-size: 0.24rem;
          &:active{
            opacity: 0.8;
          }
        }
      }
    }
  }
  .size-select{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    .size-box{
      background-color: #fff;
      width: 10.8rem;
      height: 7rem;
      border-radius: 0.5rem;
      .list{
        margin: 0.46rem 0.8rem;
        height: 6.08rem;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        overflow: hidden;
        .item{
            width: 1.5rem;
            height: 1.5rem;
            border: 0.01rem solid rgba(15,64,245,1);
            border-radius: 0.1rem;
            box-sizing: border-box;
            margin: 0.01rem;
            background-color: rgba(15,64,245,0.1);
            &.select{
              cursor: pointer;
              background-color: rgba(15,64,245,1);
              display: flex;
              align-items: center;
              justify-content: center;
              font-size: 0.42rem;
              color: #fff;
              &:active{
                opacity: 0.8;
              }
              &.disabled{
                background-color: #DDD;
                border: 0.01rem solid #DDD;
                &:active{
                  opacity: 1;
                }
              }
            }
        }
      }
    }
    .close{
      position: absolute;
      top: 1rem;
      right: 1rem;
      width: 0.8rem;
      height: 0.8rem;
      background-image: url('../assets/img/close.png');
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
  .order-select{
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 10;
    padding: 0.6rem;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    .order-search{
      width: 100%;
      .el-form{
        width: 100%;
        box-sizing: border-box;
        .el-form-item{
          margin: 0;
          margin-bottom: 0.3rem;
          input{
            height: 0.54rem;
            line-height: 0.54rem;
            font-size: 0.22rem;
            padding: 0 0.15rem;
          }
          .el-form-item__label,.el-form-item__content{
            line-height: 0.54rem;
            font-size: 0.22rem;
            padding: 0 0.12rem 0 0;
          }
          .el-input__icon{
            line-height: 0.54rem;
          }
          .primary_btn{
            cursor: pointer;
            display: inline-block;
            padding: 0 0.2rem;
            height: 0.6rem;
            line-height: 0.6rem;
            text-align: center;
            border-radius: 0.05rem;
            background-color: #0F40F5;
            color: #fff;
            font-size: 0.24rem;
            margin-right: 0.2rem;
            &:hover,&:active{
              opacity: 0.8;
            }
          }
          .info_btn{
            cursor: pointer;
            display: inline-block;
            padding: 0 0.2rem;
            height: 0.6rem;
            line-height: 0.58rem;
            text-align: center;
            border-radius: 0.05rem;
            background-color: #fff;
            color: #0F40F5;
            border: 0.01rem solid #0F40F5;
            font-size: 0.24rem;
            margin-right: 0.2rem;
            box-sizing: border-box;
            &:hover,&:active{
              opacity: 0.8;
            }
          }
        }
        .form_content{
          display: flex;
          margin-right: 0.45rem;
          font-size: 0.14rem;
          width: auto;
          .el-form-item__content{
            flex: 1;
          }
          .el-input-group__append{
            padding: 0;
            width: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.2rem;
            .el-button{
              padding: 0.12rem 0.2rem;
              margin: 0;
            }
          }
        }
      }
    }
    .el-table{
      font-size: 0.3rem;
      // colgroup {
      //   col:nth-child(2){
      //     width: 1.2rem !important;
      //   }
      //   col:nth-child(3){
      //     width: 1.2rem !important;
      //   }
      //   col:nth-child(4){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(5){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(6){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(7){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(8){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(9){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(10){
      //     width: 0.9rem !important;
      //   }
      //   col:nth-child(11){
      //     width: 0.9rem !important;
      //   }
      // }
      tr.current-row {
        td.el-table__cell {
          background-color: #4E6EF2 !important;
          color: #fff;
          .pointer{
            color: #fff;
          }
        }
      }
      .pointer{
        cursor: pointer;
        color: #4E6EF2;
      }
      .cell{
        width: 100% !important;
        box-sizing: border-box;
        font-size: 0.24rem;
        line-height: 0.45rem;
        padding: 0 0.05rem;
      }
      .el-table__cell{
        padding: 0.12rem 0;
      }
    }
    .el-pagination{
      margin-top: 0.3rem;
      padding: 0;
    }
  }
}
</style>
